module.exports = __webpack_public_path__ + "static/media/dalbergia_img.7052076c.jpg";